import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { selectCateringCartFilters } from "../../redux/features/restaurants/restaurantSelectors";
import { setCateringCartFilters } from "../../redux/features/restaurants/restaurantSlice";

const PaxSelector = ({ disabled = false }) => {
  const dispatch = useDispatch();
  const filters = useSelector(selectCateringCartFilters);
  
  console.log('🎯 PaxSelector - Disabled Status:', {
    'disabled prop': disabled,
    'currentPax': filters.pax
  });
  
  // Default PAX to 5 if not set
  const currentPax = filters.pax || 5;
  const minPax = 5;
  const maxPax = 100; // Reasonable maximum
  const increment = 5;

  const handleIncreasePax = () => {
    if (disabled) return;
    const newPax = Math.min(currentPax + increment, maxPax);
    dispatch(setCateringCartFilters({ ...filters, pax: newPax }));
  };

  const handleDecreasePax = () => {
    if (disabled) return;
    const newPax = Math.max(currentPax - increment, minPax);
    dispatch(setCateringCartFilters({ ...filters, pax: newPax }));
  };

  return (
    <div className={`flex items-center gap-4 ${disabled ? 'opacity-50' : ''}`}>
      <span className="font-bold text-lg text-gray-400">PAX</span>
      <div className="flex items-center border border-gray-300 rounded-lg">
        <button
          onClick={handleDecreasePax}
          disabled={disabled || currentPax <= minPax}
          className={`px-3 py-2 text-lg font-bold ${
            disabled || currentPax <= minPax
              ? 'text-gray-400 cursor-not-allowed'
              : 'text-gray-700 hover:bg-gray-100'
          }`}
        >
          -
        </button>
        <div className="px-4 py-2 text-lg font-bold text-gray-700 min-w-[60px] text-center border-x border-gray-300">
          {currentPax}
        </div>
        <button
          onClick={handleIncreasePax}
          disabled={disabled || currentPax >= maxPax}
          className={`px-3 py-2 text-lg font-bold ${
            disabled || currentPax >= maxPax
              ? 'text-gray-400 cursor-not-allowed'
              : 'text-gray-700 hover:bg-gray-100'
          }`}
        >
          +
        </button>
      </div>
    </div>
  );
};

export default PaxSelector;
